export const MAY_BALL_ACTIVITY_START_TIME = new Date(
  '2026-05-15T00:00:00Z'
).getTime()

export const MAY_BALL_ACTIVITY_END_TIME = new Date(
  '2026-06-09T23:59:59Z'
).getTime()

export const MAY_BALL_ACTIVITY_END_TIME_SECONDS = Math.floor(
  MAY_BALL_ACTIVITY_END_TIME / 1000
)

export const isMayBallActivityActive = (now = Date.now()) =>
  now >= MAY_BALL_ACTIVITY_START_TIME && now <= MAY_BALL_ACTIVITY_END_TIME

export const getMayBallActivityStatusChangeDelay = (now = Date.now()) => {
  if (now < MAY_BALL_ACTIVITY_START_TIME) {
    return MAY_BALL_ACTIVITY_START_TIME - now
  }
  if (now <= MAY_BALL_ACTIVITY_END_TIME) {
    return MAY_BALL_ACTIVITY_END_TIME - now + 1000
  }
  return 0
}
